import React from 'react';
import { InventoryListTemplate } from 'themes/modules/product-inventory/pages';
import { InventoryListViewStore } from 'modules/product-inventory/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new InventoryListViewStore(rootStore), 'inventoryListViewStore')
class InventoryList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<InventoryListTemplate
				{...this.props}
				change={this.props.inventoryListViewStore.change}
				actions={this.props.inventoryListViewStore}
				showActions={this.props.inventoryListViewStore.showActions}
				viewStore={this.props.inventoryListViewStore}
			/>
		);
	}
}

export default InventoryList;



// WEBPACK FOOTER //
// ./src/modules/product-inventory/pages/InventoryList.jsx